<template>
  <!-- 当前展览 -->
  <div class="page-exhibition">
    <div class="g-content-wrap">
      <cmpTitle class="mb-30" title="十佳社教活动"></cmpTitle>
      <div class="tc mb-30">
        <el-date-picker
          v-model="year"
          type="year"
          placeholder="选择年"
          @change="handleSearch">
        </el-date-picker>
      </div>
      <div class="list-advance">
        <div class="item g-card-2" v-for="(item, index) in dataList" :key="index" @click="goDetailCollect(item)">
          <div class="pic-box">
            <img v-lazy="item.showPic" alt="">
            <div class="count-fl">{{index+1}}</div>
          </div>
          <div class="g-border-box white">
            <div class="g-border">
              <span class="g-bor-dec g-bor-dec-1"></span>
              <span class="g-bor-dec g-bor-dec-2"></span>
              <span class="g-bor-dec g-bor-dec-3"></span>
              <span class="g-bor-dec g-bor-dec-4"></span>

              <div class="info">
                <h2 class="ell">撒大声地发送到发送到发送到</h2>
                <p>所属单位：淄博市博物馆</p>
                <p class="three-ell mt-20">入选简评：菩提本无树，明镜亦非台，本来无一物，何处惹尘埃。庚子年九月廿九，普陀山观音文化园观音法界将正式开园。菩提本无树，明镜亦非台，本来无一物，何处惹尘埃。庚子年九月廿九，普陀山观音文化园观音法界将正式开园。菩提本无树，明镜亦非台，本来无一物，何处惹尘埃。庚子年九月廿九，普陀山观音文化园观音法界将正式开园。菩提本无树，明镜亦非台，本来无一物，何处惹尘埃。庚子年九月廿九，普陀山观音文化园观音法界将正式开园。</p>
              </div>
            </div>
          </div>
        </div>
        <!-- 无数据 -->
        <div class="g-no-data" v-if="dataList.length === 0 && !listLoading">
          <div class="no-data-bg"></div>
          <p class="txt text-center">暂无数据</p>
        </div>
      </div>

      <!-- <cmpMyPagination :currentPage="listQuery.currentPage" :pageSize="listQuery.size" :total="total" @eventPage="eventPage"></cmpMyPagination> -->
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      year: '',
      dataList: [],
      listQuery: {
        currentPage: 1,
        size: 6,
      },
      total: 0,
      listLoading: false,
      form: {
        schemeName: '',
        dataState: ''
      },
      planState: [
        {
          dictName: '年代1',
          dictCode: 1
        },
        {
          dictName: '年代2',
          dictCode: 2
        },
        {
          dictName: '年代3',
          dictCode: 3
        },
      ]
    }
  },
  watch: {
    $route(to, from) {
      this.$router.go(0)
      // this.$router.replace({
      //   path: to.path,
      //   query: { type: to.query.type || '', com: to.query.com || '' }
      // }).catch(err => {err})
    }
  },
  methods: {
    getDataList() {
      this.listLoading = true
      this.$http
        .get('/exhibition/list', {
          ...this.listQuery,
          type: '1'
        })
        .then(res => {
          this.listLoading = false
          if (res.success) {
            this.dataList = res.data
            this.total = res.page.allRow
          } else {
            this.$message.error(res.message)
          }
        })
    },
    handleSearch() {
      this.listQuery.currentPage = 1
      this.getDataList()
    },
    goDetailCollect(item) {
      this.$router.push({
        path: '/collect/detail',
        query: {id: '1'}
      })
    },
    goDetailTopic(item) {
      this.$router.push({
        path: '/collect/topic/detail',
        query: {id: '1'}
      })
    },
    eventPage(obj) {
      this.listQuery.currentPage = obj.currentPage
      this.listQuery.size = obj.size
      this.getDataList()
    },
  },
  created() {
    this.getDataList()
  }
}
</script>

<style lang="scss" scoped>
.page-exhibition {
  
}
</style>

